import React, { useRef, useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from "reactstrap";
import SignatureCanvas from "react-signature-canvas";

const SignCanvas = ({ isCanvasOpen, setIsCanvasOpen, onSave, existingSign }) => {
  const signatureRef = useRef(null);
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isCanvasOpen) {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
            setError(null);
          },
          (error) => {
            setError("Lokasi tidak dapat diakses: " + error.message);
          }
        );
      } else {
        setError("Geolocation tidak didukung di browser ini");
      }

      if (existingSign && signatureRef.current) {
        const img = new Image();
        img.src = existingSign;
        img.onload = () => {
          const canvas = signatureRef.current.getCanvas();
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        };
      }
    }
  }, [isCanvasOpen, existingSign]);

  const handleClear = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  const handleSave = () => {
    if (signatureRef.current) {
      const signature = signatureRef.current.getTrimmedCanvas().toDataURL("image/png");
      onSave(signature, location?.latitude, location?.longitude);
    }
  };

  return (
    <Modal isOpen={isCanvasOpen} toggle={() => setIsCanvasOpen(false)} size="lg" fullscreen="md">
      <ModalHeader toggle={() => setIsCanvasOpen(false)}>
        Tanda Tangan
      </ModalHeader>
      <ModalBody className="d-flex flex-column justify-content-center align-items-center">
        {error && (
          <Alert color="warning" className="mb-3">
            {error}
          </Alert>
        )}
        {location && (
          <Alert color="info" className="align-self-stretch mb-3">
            Lokasi terdeteksi: {location.latitude}, {location.longitude}
          </Alert>
        )}
        <SignatureCanvas
          ref={signatureRef}
          canvasProps={{
            width: 600,
            height: 400,
            style: { border: "4px solid black", borderRadius: "4px", margin: "auto" }
          }}
          minWidth={3}
          maxWidth={5}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleClear}>
          Hapus
        </Button>
        <Button color="success" onClick={handleSave}>
          Simpan
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SignCanvas;